import {PaymentElement} from '@stripe/react-stripe-js';
import {StripePaymentElementOptions} from '@stripe/stripe-js';

type StripePaymentElementFormProps = {
  onFormReady?: () => void;
  onFormComplete?: (state: boolean) => void;
};
export const StripePaymentForm = ({
  onFormReady,
  onFormComplete,
}: StripePaymentElementFormProps) => {
  const paymentElementOptions: StripePaymentElementOptions = {
    layout: {
      type: 'tabs',
      defaultCollapsed: false,
    },
    wallets: {
      applePay: 'auto',
      googlePay: 'auto',
      link: 'never',
    },
    fields: {
      billingDetails: {
        address: 'if_required',
      },
    },
  };
  return (
    <PaymentElement
      options={paymentElementOptions}
      onReady={onFormReady}
      onChange={event => onFormComplete?.(event.complete)}
    />
  );
};
